import classNames from 'classnames'
import { HeaderView } from '../header-view/HeaderView'
import './styles.scss'

type OrderDeliveryTypeObject = {
  onClick: () => void
  title: string | React.ReactNode
  icon: React.ReactNode
  subtitle?: string
  description: React.ReactNode
  disabled?: boolean
}
type Props = {
  primary: OrderDeliveryTypeObject
  secondary: OrderDeliveryTypeObject
  title: string
  highlightSecondary?: boolean
}

export function OrderDeliveryType({ primary, secondary, title, highlightSecondary }: Props) {
  return (
    <div className='order-delivery-type-container'>
      <HeaderView title='Add new Order' />

      <div className='order-delivery-type-inner-container'>
        <div>
          <div className='order-delivery-type-heading'>{title}</div>

          <div className='order-delivery-type-items-container'>
            <div className='order-delivery-type-item-container'>
              <div
                className='order-delivery-type-item'
                onClick={primary.onClick}
                role='button'
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    primary.onClick()
                  }
                }}>
                {primary.icon}
                <div className='order-delivery-type-heading'>{primary.title}</div>
                {primary.subtitle ? <div className='order-delivery-type-subtitle'>{primary.subtitle}</div> : null}
                <div className='order-delivery-type-item-description'>{primary.description}</div>
              </div>
              {primary.disabled ? <div className='order-delivery-type-disabled-container' /> : null}
            </div>
            <div className='order-delivery-type-item-container'>
              <div
                className={classNames('order-delivery-type-item', {
                  thrive: highlightSecondary && !secondary.disabled,
                })}
                onClick={secondary.onClick}
                role='button'
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    secondary.onClick()
                  }
                }}>
                {secondary.icon}
                <div className='order-delivery-type-heading'>{secondary.title}</div>
                {secondary.subtitle ? <div className='order-delivery-type-subtitle'>{secondary.subtitle}</div> : null}

                <div className='order-delivery-type-item-description'>{secondary.description}</div>
              </div>
              {secondary.disabled ? <div className='order-delivery-type-disabled-container' /> : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
